export interface MarketProduct {
  id: number;
  name: string;
  images: {
    image: string;
    sequence: number;
  }[];
  is_permanent: boolean;
  price: number;
  original_price: number;
  discount_rate: number;
  open_at: string;
  open_until: string;
  review_data: {
    counts: number;
    avr_rating: number;
  };
}

export interface MarketReview {
  id: number;
  campaign_id: number;
  created_at: string;
  campaign_name: string;
  contents: string;
  rating: number;
  medias: {
    id: number;
    url: string;
    sequence: number;
  }[];
}

export interface MarketInfo {
  id: number;
  market_banners: {
    image: string;
  }[];
  market_setting: {
    notice_text: string;
    logo_text: string;
    logo_image: string;
    is_review_visible: boolean;
    logo_type: 'text' | 'image';
  };
  reviews: MarketReview[];
  campaigns: MarketProduct[];
  seller: {
    company_name: string;
    ceo_name: string;
    business_number: string;
    online_sales_number: string;
    location: string;
    email: string;
  };
  categories: string[];
}

export interface MarketInfoV2 {
  id: number;
  market_banners: {
    image: string;
  }[];
  market_setting: {
    notice_text: string;
    logo_text: string;
    logo_image: string;
    is_review_visible: boolean;
    logo_type: 'text' | 'image';
  };
  reviews: MarketReview[];
  campaigns: MarketProduct[];
  market_info: {
    company_name: string;
    ceo_name: string;
    business_number: string;
    online_sales_number: string;
    location: string;
    cs_email: string;
    cs_phone: string;
    cs_channel: string;
  };
  categories: string[];
}

export interface Pagination<T> {
  count: number;
  current_page: number;
  total_page: number;
  results: T[];
}

export interface MarketProductInfo {
  count: number;
  current_page: number;
  total_page: number;
  results: MarketProduct[];
}

export enum MARKET_STATUS {
  NOT_CONTRACTED = 'not_contracted',
  DRAFTING = 'drafting',
  UNDER_REVIEW = 'under_review',
  UNDER_CARD_REVIEW = 'under_card_review',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  REJECTED = 'rejected',
}
